
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertProprietors (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/proprietor',
    method: 'POST',
    data: parameter
  })
}
export function updateProprietors (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/proprietor',
    method: 'POST',
    data: parameter
  })
}
export function deleteProprietors (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/proprietor/' + parameter,
    method: 'DELETE'
  })
}
export function getProprietorsList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/proprietors',
    method: 'GET',
    params: parameter
  })
}
export function getProprietorsInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/proprietors',
    method: 'GET',
    params: parameter
  })
}
// 修改业主状态
export function modifyProprietorsStatus (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/proprietor',
    method: 'PUT',
    data: parameter
  })
}
